// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/amazingStyles.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Catalogue_container__JrNJF {
  width: 100%;
  height: 100%;
}
.Catalogue_container_heading__jlOxk {
  display: flex;
  align-items: center;
  padding-inline: 4rem;
  gap: 2rem;
  width: 100%;
  height: 7rem;
  background-color: var(--color-primary-5);
}
.Catalogue_container_heading__shape__24mmg {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--default-font-h2);
  font-weight: 700;
  background-color: var(--color-white);
  width: 5rem;
  height: 5rem;
  border-radius: 9rem;
}

.Catalogue_breadCrumbs__c7Z4N {
  background-color: var(--color-primary);
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
  z-index: 100;
  cursor: pointer;
}

.Catalogue_inActive__SV2JE {
  background-color: var(--color-primary-8);
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
  z-index: 100;
  cursor: pointer;
}

.Catalogue_breadCrumbsBox__F7V3S {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.Catalogue_imageContainer__dQ7yK {
  display: flex;
  height: 80rem;
  justify-content: center;
  margin-top: 2rem;
}
@media only screen and (max-width: 25em) {
  .Catalogue_imageContainer__dQ7yK {
    height: 60rem;
    width: 80%;
  }
}

.Catalogue_smallImages__kBUTJ {
  display: flex;
  flex-direction: column;
  height: 70rem;
  gap: 2rem;
  padding: 0 2rem;
}
@media only screen and (max-width: 25em) {
  .Catalogue_smallImages__kBUTJ {
    height: 50rem;
  }
}

.Catalogue_smallImage__Kfayp {
  width: 15rem;
  height: 17rem;
  cursor: pointer;
}
@media only screen and (max-width: 25em) {
  .Catalogue_smallImage__Kfayp {
    width: 10rem;
    height: 12rem;
  }
}

.Catalogue_largeImageContainer__GURF9 {
  width: 50rem;
  height: 70rem;
}

.Catalogue_largeImage__-bT91 {
  width: 100%;
  height: 70rem;
  object-fit: cover;
  cursor: pointer;
  padding: 1rem;
}
@media only screen and (max-width: 25em) {
  .Catalogue_largeImage__-bT91 {
    width: 80%;
    height: 50rem;
  }
}

.Catalogue_selectedSmallImage__yXaBO {
  border: 2px solid var(--color-primary);
}

.Catalogue_selectedLargeImage__cBU\\+7 {
  border: 2px solid var(--color-primary);
}

.Catalogue_section__riptd {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 2rem;
  padding: 4rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_section__riptd {
    grid-template-columns: 1fr;
  }
}
.Catalogue_section_form__8YV42 {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 10rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_section_form__8YV42 {
    margin-top: 0;
  }
}
@media only screen and (max-width: 25em) {
  .Catalogue_section_form__8YV42 {
    width: 80%;
  }
}

.Catalogue_line__P\\+mlY {
  width: 100%;
  margin: 2rem 0;
  border: solid 1px;
}

.Catalogue_btn__ENN2Y {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin: 4rem 0;
}

/* Pagination.css */
.Catalogue_pagination__soD-m {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 4rem;
}

.Catalogue_pagination__soD-m li {
  margin: 0 5px;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 5px 10px;
}

.Catalogue_pagination__soD-m li.Catalogue_active__zc7Hz {
  font-weight: bold;
  color: blue;
  background-color: #f0f0f0;
}

.Catalogue_dtl__CqjzB {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Catalogue_img__ULSd4 {
  width: 100%;
  height: 25rem;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.Catalogue_img__ULSd4:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.Catalogue_catalog__ZArYc {
  font-family: var(--tertiary-font);
  position: relative;
}
.Catalogue_catalog__header__JYqu6 {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: var(--color-white);
}
.Catalogue_catalog__header__business__IYbUw {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
}
.Catalogue_catalog__header__business__IYbUw img {
  height: 5rem;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_catalog__header__business__IYbUw {
    flex-direction: column;
  }
}
.Catalogue_catalog__header__business__name__HpfVg {
  font-size: 2.4rem;
  font-weight: 700;
  text-align: center;
}
.Catalogue_catalog__header__inner__ev96X {
  border-bottom: 0.5px solid #d8d8d8;
  min-height: 7rem;
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  gap: 1rem;
  padding: 1.5rem 5rem;
  align-items: center;
  position: relative;
}
@media only screen and (max-width: 37.5em) {
  .Catalogue_catalog__header__inner__ev96X {
    padding: 1.5rem 2rem;
  }
}
.Catalogue_catalog__header__nav__J1zqd {
  min-height: 4rem;
  border-bottom: 0.5px solid #d8d8d8;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Catalogue_catalog__header__nav__selected__5syDX {
  border-bottom: 1px solid var(--color-dark);
  width: fit-content;
}
.Catalogue_catalog__header__nav__J1zqd ul {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;
  font-size: var(--default-font-small);
  font-weight: 500;
  gap: 1.5rem;
}
.Catalogue_catalog__header__nav__J1zqd ul li {
  cursor: pointer;
}
.Catalogue_catalog__header__nav__J1zqd ul li:hover {
  font-weight: 700;
  border-bottom: 1px solid var(--color-dark);
  width: fit-content;
}
@media only screen and (max-width: 37.5em) {
  .Catalogue_catalog__header__nav__J1zqd {
    padding: 0 2rem;
  }
}
.Catalogue_catalog__header__nav__more__nBxuh {
  width: 100%;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 12;
  min-height: 40vh;
}
.Catalogue_catalog__body__BqAwt {
  position: relative;
  margin-top: 13rem;
}
@media only screen and (max-width: 43.75em) {
  .Catalogue_catalog__body__BqAwt {
    margin-top: 17rem;
  }
}
.Catalogue_catalog__body__inner__dPptR {
  padding: 0 5rem;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_catalog__body__inner__dPptR {
    padding: 0 2rem;
  }
}
.Catalogue_catalog__icons__Crjop {
  font-size: 3rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  align-items: center;
}
.Catalogue_catalog__icons__Crjop > * {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}
.Catalogue_catalog__icons__Crjop > *:hover {
  transform: scale(1.1);
}
.Catalogue_catalog__search__icon__xalVa {
  font-size: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.Catalogue_catalog__embla__viewport__44tlG {
  overflow: hidden;
  position: relative;
}
.Catalogue_catalog__embla__container__EEG4d {
  display: flex;
}
.Catalogue_catalog__embla__slide__L8m\\+F {
  flex: 0 0 100%;
  min-width: 0;
}
.Catalogue_catalog__embla__btn__RB8da {
  background-color: var(--color-white);
  font-size: 2rem;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
}
.Catalogue_catalog__embla__btn__RB8da:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
}
.Catalogue_catalog__embla__btns__Hqrxo {
  display: flex;
  width: 100%;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 40%;
  padding: 1rem;
}
.Catalogue_catalog__embla__onSale__qGZ\\+l {
  background-color: var(--color-primary);
  color: var(--color-white);
  font-weight: 600;
  padding: 1rem;
  width: fit-content;
  position: absolute;
  top: 1rem;
  left: 1rem;
}
.Catalogue_catalog__embla__prev__kk0vl {
  left: 1.5rem;
}
.Catalogue_catalog__embla__next__xElko {
  right: 1.5rem;
}
.Catalogue_catalog__embla__dots__mx8b4 {
  content: "";
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 2rem;
}
.Catalogue_catalog__embla__dots__mx8b4 > * {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 1px solid var(--color-fash-primary-2);
  cursor: pointer;
}
.Catalogue_catalog__embla__dots__mx8b4 > *:hover {
  background-color: var(--color-fash-primary-2);
}
.Catalogue_catalog__embla__dots__active__eb0jM {
  background-color: var(--color-fash-primary-2);
}
.Catalogue_catalog__modal__yAlsu {
  background-color: rgba(42, 40, 40, 0.7019607843);
  display: grid;
  grid-template-columns: 100%;
  height: 100vh;
  position: fixed;
  width: 100vw;
  z-index: 100;
}
.Catalogue_catalog__modal__nav__5N4iS {
  height: fit-content;
  max-height: 60vh;
  width: fit-content;
  background-color: var(--color-white);
  display: flex;
}
.Catalogue_catalog__modal__nav__5N4iS > :first-child {
  min-width: 30rem;
  max-width: 40rem;
  padding: 2rem;
  padding-right: 4rem;
  overflow-y: auto;
}
.Catalogue_catalog__modal__nav__5N4iS > :first-child ul {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-weight: 500;
}
.Catalogue_catalog__modal__nav__5N4iS > :first-child ul li {
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1.9rem;
}
.Catalogue_catalog__modal__nav__5N4iS > :first-child ul li:hover {
  font-weight: 700;
  border-bottom: 1px solid var(--color-dark);
  width: fit-content;
}
.Catalogue_catalog__modal__nav__explore__zIgs0 {
  flex-grow: 1;
  background-image: linear-gradient(97deg, rgba(41, 35, 1, 0.7) 35%, rgba(12, 9, 13, 0.7) 80%), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  padding: 2rem;
  display: flex;
  align-items: flex-end;
}
.Catalogue_catalog__modal__yAlsu > :last-child {
  height: 40vh;
  cursor: pointer;
}
.Catalogue_catalog__banner__Uc8V7 {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  min-height: 60rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 5rem 0;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_catalog__banner__Uc8V7 {
    min-height: 60vh;
  }
}
.Catalogue_catalog__banner__text__4rzqj {
  font-size: 3.2rem;
  color: var(--color-white);
  width: fit-content;
  max-width: 80%;
  text-align: center;
}

.Catalogue_more__Wzrfv {
  height: fit-content;
  max-height: 60vh;
  width: fit-content;
  background-color: var(--color-white);
  display: flex;
  min-width: 35rem;
  max-width: 40rem;
  padding: 2rem;
  padding-right: 4rem;
  overflow-y: auto;
  position: absolute;
  right: 0;
  z-index: 101;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_more__Wzrfv {
    right: auto;
    top: 3rem;
  }
}
.Catalogue_more__Wzrfv ul {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-weight: 500;
}
.Catalogue_more__Wzrfv ul li {
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1.9rem;
}
.Catalogue_more__Wzrfv ul li:hover {
  font-weight: 700;
  border-bottom: 1px solid var(--color-dark);
  width: fit-content;
}
.Catalogue_more__rel__J\\+TKy {
  position: relative;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_more__rel__J\\+TKy {
    display: flex;
    justify-content: center;
  }
}

.Catalogue_more2__BvmpF {
  height: fit-content;
  max-height: 60vh;
  width: fit-content;
  background-color: var(--color-white);
  display: flex;
  min-width: 35rem;
  max-width: 40rem;
  padding: 2rem;
  padding-right: 4rem;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 3rem;
  z-index: 101;
}
@media only screen and (max-width: 31.25em) {
  .Catalogue_more2__BvmpF {
    right: -10vw;
  }
}
@media only screen and (max-width: 25em) {
  .Catalogue_more2__BvmpF {
    right: -13vw;
  }
}
.Catalogue_more2__BvmpF ul {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-weight: 500;
}
.Catalogue_more2__BvmpF ul li {
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1.9rem;
}
.Catalogue_more2__BvmpF ul li:hover {
  font-weight: 700;
  border-bottom: 1px solid var(--color-dark);
  width: fit-content;
}

.Catalogue_single__kR15W {
  padding: 10rem 5rem;
}
@media only screen and (max-width: 37.5em) {
  .Catalogue_single__kR15W {
    padding: 5rem 2rem;
  }
}
.Catalogue_single__grid2__9I-0- {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.Catalogue_single__grid__JhRMo {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_single__grid__JhRMo {
    grid-template-columns: 100%;
  }
}
.Catalogue_single__grid__images__0qfnT {
  display: grid;
  grid-template-columns: 10rem 1fr;
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_single__grid__images__0qfnT {
    grid-template-columns: 100%;
  }
  .Catalogue_single__grid__images__0qfnT > :first-child {
    grid-row: 2;
  }
  .Catalogue_single__grid__images__0qfnT > :last-child {
    grid-row: 1;
  }
}
.Catalogue_single__grid__images__main__vI\\+eL {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.Catalogue_single__grid__images__main__vI\\+eL img {
  width: 100%;
  object-fit: cover;
  background-color: var(--color-white);
}
.Catalogue_single__grid__images__list__6RcNh {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .Catalogue_single__grid__images__list__6RcNh {
    flex-direction: row;
  }
}
.Catalogue_single__grid__images__list__sel__DOJIi {
  border: 1px solid var(--color-fash-primary-2);
  height: fit-content;
  width: fit-content;
}
.Catalogue_single__grid__images__list__6RcNh img {
  width: 10rem;
  height: 10rem;
  box-sizing: border-box;
  padding: 1rem;
  border-radius: 1rem;
  cursor: pointer;
  object-fit: cover;
  background-color: var(--color-white);
}
@media only screen and (max-width: 25em) {
  .Catalogue_single__grid__images__list__6RcNh img {
    width: 9rem;
    height: 9rem;
  }
}
.Catalogue_single__grid__details__BP\\+Od {
  display: flex;
  flex-direction: column;
}
.Catalogue_single__price__fZR4u {
  border: 1px solid var(--color-grey);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin-bottom: 2rem;
}
.Catalogue_single__price__fZR4u > :nth-child(2) {
  font-size: var(--default-font-subtitle);
  font-weight: 700;
}
.Catalogue_single__price__active__ldhx0 {
  border: 2px solid var(--color-fash-primary-2);
}
.Catalogue_single__price__active__ldhx0 > :nth-child(2) {
  color: var(--color-fash-primary-2);
}

.Catalogue_h__divider__b6znT {
  content: "";
  border: 1px solid var(--color-grey);
  width: 100%;
  margin: 2rem 0;
}

.Catalogue_zoomed__iv2\\+T {
  display: block;
  cursor: pointer;
}
.Catalogue_zoomed__image__y6y6i {
  background-size: 300% auto;
  /* Adjust the background size for zoom level */
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.1s ease-in-out;
  display: block;
}

.Catalogue_country__07rsU {
  position: relative;
}
.Catalogue_country__sel__rq50m {
  display: flex;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
}
.Catalogue_country__sel__rq50m img {
  width: 5rem;
}
.Catalogue_country__drop__o6hJh {
  position: absolute;
  border: 1px solid var(--color-dark);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-white);
  min-width: 20rem;
  top: 5rem;
  left: 0;
  z-index: 12;
}
.Catalogue_country__drop__o6hJh > :first-child:hover {
  border-radius: 8px 8px 0 0;
}
.Catalogue_country__drop__o6hJh > :last-child:hover {
  border-radius: 0 0 8px 8px;
}
.Catalogue_country__drop__item__KR28h {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
}
.Catalogue_country__drop__item__KR28h img {
  width: 5rem;
}
.Catalogue_country__drop__item__KR28h:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}

.Catalogue_cartIcon__FBh8Q {
  position: relative;
}
.Catalogue_cartIcon__nos__EK9a6 {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-size: 7px;
  border-radius: 50%;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -5px;
  right: -5px;
}

.Catalogue_sales__1uDUQ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.Catalogue_sales__cancel__OqXeN {
  text-decoration: line-through;
}

.Catalogue_shopTitle__R7rwz {
  font-size: 4rem;
  font-weight: 400;
  line-height: 4rem;
  margin-top: 16rem;
  text-align: center;
}
@media only screen and (max-width: 43.75em) {
  .Catalogue_shopTitle__R7rwz {
    margin-top: 19rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Catalogue/Catalogue.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,YAAA;AADD;AAGC;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AADF;AAGE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADH;;AAMA;EACC,sCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHD;;AAMA;EACC,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHD;;AAMA;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAHD;;AAMA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAHD;AAKC;EAND;IAOE,aAAA;IACA,UAAA;EAFA;AACF;;AAKA;EACC,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AAFD;AAIC;EAPD;IAQE,aAAA;EADA;AACF;;AAIA;EACC,YAAA;EACA,aAAA;EACA,eAAA;AADD;AAGC;EALD;IAME,YAAA;IACA,aAAA;EAAA;AACF;;AAGA;EACC,YAAA;EACA,aAAA;AAAD;;AAGA;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AAAD;AAEC;EAPD;IAQE,UAAA;IACA,aAAA;EACA;AACF;;AAEA;EACC,sCAAA;AACD;;AAEA;EACC,sCAAA;AACD;;AAEA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AACD;AACC;EAPD;IAQE,0BAAA;EAEA;AACF;AAAC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAEF;AAAE;EAND;IAOE,aAAA;EAGD;AACF;AADE;EAVD;IAWE,UAAA;EAID;AACF;;AAAA;EACC,WAAA;EACA,cAAA;EACA,iBAAA;AAGD;;AAAA;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AAGD;;AAAA,mBAAA;AAEA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAED;;AACA;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAED;;AACA;EACC,iBAAA;EACA,WAAA;EACA,yBAAA;AAED;;AACA;EACC,aAAA;EACA,8BAAA;EACA,YAAA;AAED;;AACA;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;AAED;AAAC;EACC,qBAAA;EACA,+BAAA;AAEF;;AAEA;EACC,iCAAA;EACA,kBAAA;AACD;AACC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;AACF;AACE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AACH;AACG;EACC,YAAA;AACJ;AAEG;EAVD;IAWE,sBAAA;EACF;AACF;AACG;EACC,iBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAIE;EACC,kCAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kDAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAFH;AASG;EAhBD;IAiBE,oBAAA;EANF;AACF;AAoCE;EACC,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlCH;AAoCG;EACC,0CAAA;EACA,kBAAA;AAlCJ;AAqCG;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EAEA,WAAA;AApCJ;AAsCI;EACC,eAAA;AApCL;AAsCK;EACC,gBAAA;EACA,0CAAA;EACA,kBAAA;AApCN;AA2CG;EApCD;IAqCE,eAAA;EAxCF;AACF;AA0CG;EACC,WAAA;EAKA,oCAAA;EACA,4CAAA;EACA,WAAA;EACA,gBAAA;AA5CJ;AAiDC;EACC,kBAAA;EACA,iBAAA;AA/CF;AAiDE;EAJD;IAKE,iBAAA;EA9CD;AACF;AAgDE;EACC,eAAA;AA9CH;AAgDG;EAHD;IAIE,eAAA;EA7CF;AACF;AAiDC;EACC,eAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AA/CF;AAiDE;EACC,eAAA;EACA,sCAAA;AA/CH;AAiDG;EACC,qBAAA;AA/CJ;AAsDE;EACC,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AApDH;AAiEE;EACC,gBAAA;EACA,kBAAA;AA/DH;AAkEE;EACC,aAAA;AAhEH;AAmEE;EACC,cAAA;EACA,YAAA;AAjEH;AAoEE;EACC,oCAAA;EAEA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAlEH;AAoEG;EACC,mCAAA;EACA,yBAAA;AAlEJ;AAsEE;EACC,aAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;AApEH;AAuEE;EACC,sCAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AArEH;AAwEE;EACC,YAAA;AAtEH;AAyEE;EACC,aAAA;AAvEH;AA0EE;EACC,WAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAxEH;AA0EG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,eAAA;AAxEJ;AA0EI;EACC,6CAAA;AAxEL;AA4EG;EACC,6CAAA;AA1EJ;AA+EC;EACC,gDAAA;EACA,aAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AA7EF;AA+EE;EACC,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;AA7EH;AA+EG;EACC,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA7EJ;AA+EI;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA7EL;AA+EK;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AA7EN;AA+EM;EACC,gBAAA;EACA,0CAAA;EACA,kBAAA;AA7EP;AAmFG;EACC,YAAA;EACA,qIAAA;EAIA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;AApFJ;AAwFE;EACC,YAAA;EACA,eAAA;AAtFH;AA0FC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;AAxFF;AA0FE;EAbD;IAcE,gBAAA;EAvFD;AACF;AAyFE;EACC,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAvFH;;AA4FA;EACC,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAzFD;AA2FC;EAfD;IAgBE,WAAA;IACA,SAAA;EAxFA;AACF;AA0FC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAxFF;AA0FE;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AAxFH;AA0FG;EACC,gBAAA;EACA,0CAAA;EACA,kBAAA;AAxFJ;AA6FC;EACC,kBAAA;AA3FF;AA6FE;EAHD;IAIE,aAAA;IACA,uBAAA;EA1FD;AACF;;AA8FA;EACC,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA3FD;AA6FC;EAhBD;IAiBE,YAAA;EA1FA;AACF;AA4FC;EApBD;IAqBE,YAAA;EAzFA;AACF;AA2FC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAzFF;AA2FE;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AAzFH;AA2FG;EACC,gBAAA;EACA,0CAAA;EACA,kBAAA;AAzFJ;;AAgGA;EACC,mBAAA;AA7FD;AA+FC;EAHD;IAIE,kBAAA;EA5FA;AACF;AA8FC;EACC,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AA5FF;AA+FC;EACC,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AA7FF;AA+FE;EAND;IAOE,2BAAA;EA5FD;AACF;AA8FE;EACC,aAAA;EACA,gCAAA;EACA,SAAA;AA5FH;AA8FG;EALD;IAME,2BAAA;EA3FF;EA6FE;IACC,WAAA;EA3FH;EA8FE;IACC,WAAA;EA5FH;AACF;AA+FG;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;AA7FJ;AA+FI;EACC,WAAA;EACA,iBAAA;EACA,oCAAA;AA7FL;AAiGG;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AA/FJ;AAiGI;EALD;IAME,mBAAA;EA9FH;AACF;AAgGI;EACC,6CAAA;EACA,mBAAA;EACA,kBAAA;AA9FL;AAiGI;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;AA/FL;AAiGK;EAVD;IAWE,WAAA;IACA,YAAA;EA9FJ;AACF;AAmGE;EACC,aAAA;EACA,sBAAA;AAjGH;AAqGC;EACC,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAnGF;AAqGE;EACC,uCAAA;EACA,gBAAA;AAnGH;AAsGE;EACC,6CAAA;AApGH;AAsGG;EACC,kCAAA;AApGJ;;AA2GC;EACC,WAAA;EACA,mCAAA;EACA,WAAA;EACA,cAAA;AAxGF;;AA4GA;EACC,cAAA;EACA,eAAA;AAzGD;AA2GC;EACC,0BAAA;EACA,8CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sCAAA;EACA,cAAA;AAzGF;;AA6GA;EACC,kBAAA;AA1GD;AA4GC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA1GF;AA4GE;EACC,WAAA;AA1GH;AA8GC;EACC,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,4CAAA;EACA,oCAAA;EACA,gBAAA;EAEA,SAAA;EACA,OAAA;EACA,WAAA;AA7GF;AAgHG;EACC,0BAAA;AA9GJ;AAmHG;EACC,0BAAA;AAjHJ;AAqHE;EACC,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAnHH;AAqHG;EACC,WAAA;AAnHJ;AAsHG;EACC,mCAAA;EACA,yBAAA;EACA,gBAAA;AApHJ;;AA0HA;EACC,kBAAA;AAvHD;AAyHC;EACC,mCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAvHF;;AA2HA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAxHD;AA0HC;EACC,6BAAA;AAxHF;;AA4HA;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAzHD;AA2HC;EAPD;IAQE,iBAAA;EAxHA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\twidth: 100%;\n\theight: 100%;\n\n\t&_heading {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding-inline: 4rem;\n\t\tgap: 2rem;\n\t\twidth: 100%;\n\t\theight: 7rem;\n\t\tbackground-color: var(--color-primary-5);\n\n\t\t&__shape {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: var(--default-font-h2);\n\t\t\tfont-weight: 700;\n\t\t\tbackground-color: var(--color-white);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 9rem;\n\t\t}\n\t}\n}\n\n.breadCrumbs {\n\tbackground-color: var(--color-primary);\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 5px;\n\tz-index: 100;\n\tcursor: pointer;\n}\n\n.inActive {\n\tbackground-color: var(--color-primary-8);\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 5px;\n\tz-index: 100;\n\tcursor: pointer;\n}\n\n.breadCrumbsBox {\n\tmargin-top: 2rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 1rem;\n}\n\n.imageContainer {\n\tdisplay: flex;\n\theight: 80rem;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\theight: 60rem;\n\t\twidth: 80%;\n\t}\n}\n\n.smallImages {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 70rem;\n\tgap: 2rem;\n\tpadding: 0 2rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\theight: 50rem;\n\t}\n}\n\n.smallImage {\n\twidth: 15rem;\n\theight: 17rem;\n\tcursor: pointer;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\twidth: 10rem;\n\t\theight: 12rem;\n\t}\n}\n\n.largeImageContainer {\n\twidth: 50rem;\n\theight: 70rem;\n}\n\n.largeImage {\n\twidth: 100%;\n\theight: 70rem;\n\tobject-fit: cover;\n\tcursor: pointer;\n\tpadding: 1rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\twidth: 80%;\n\t\theight: 50rem;\n\t}\n}\n\n.selectedSmallImage {\n\tborder: 2px solid var(--color-primary);\n}\n\n.selectedLargeImage {\n\tborder: 2px solid var(--color-primary);\n}\n\n.section {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\twidth: 100%;\n\tgap: 2rem;\n\tpadding: 4rem;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t&_form {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\tmargin-top: 10rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tmargin-top: 0;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-400) {\n\t\t\twidth: 80%;\n\t\t}\n\t}\n}\n\n.line {\n\twidth: 100%;\n\tmargin: 2rem 0;\n\tborder: solid 1px;\n}\n\n.btn {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 2rem;\n\tmargin: 4rem 0;\n}\n\n/* Pagination.css */\n\n.pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\tlist-style: none;\n\tpadding: 4rem;\n}\n\n.pagination li {\n\tmargin: 0 5px;\n\tcursor: pointer;\n\tborder: 1px solid #ccc;\n\tpadding: 5px 10px;\n}\n\n.pagination li.active {\n\tfont-weight: bold;\n\tcolor: blue;\n\tbackground-color: #f0f0f0;\n}\n\n.dtl {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 38rem;\n}\n\n.img {\n\twidth: 100%;\n\theight: 25rem;\n\tobject-fit: cover;\n\tcursor: pointer;\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: scale(1.1);\n\t\ttransition: transform 0.3s ease;\n\t}\n}\n\n.catalog {\n\tfont-family: var(--tertiary-font);\n\tposition: relative;\n\n\t&__header {\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\tz-index: 999;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tbackground-color: var(--color-white);\n\n\t\t&__business {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1rem;\n\t\t\tjustify-content: center;\n\n\t\t\timg {\n\t\t\t\theight: 5rem;\n\t\t\t}\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\tflex-direction: column;\n\t\t\t}\n\n\t\t\t&__name {\n\t\t\t\tfont-size: 2.4rem;\n\t\t\t\tfont-weight: 700;\n\t\t\t\ttext-align: center;\n\t\t\t\t// width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&__inner {\n\t\t\tborder-bottom: 0.5px solid #d8d8d8;\n\t\t\tmin-height: 7rem;\n\t\t\twidth: 100%;\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: max-content 1fr max-content;\n\t\t\tgap: 1rem;\n\t\t\tpadding: 1.5rem 5rem;\n\t\t\talign-items: center;\n\t\t\tposition: relative;\n\n\t\t\t// @media only screen and (max-width: $bp-800) {\n\t\t\t// \tgrid-template-columns: max-content 1fr;\n\t\t\t// \tgap: 1rem;\n\t\t\t// }\n\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\tpadding: 1.5rem 2rem;\n\t\t\t}\n\n\t\t\t// @media only screen and (max-width: $bp-500) {\n\t\t\t// \tgrid-template-columns: 100%;\n\t\t\t// \tgap: 1rem;\n\t\t\t// \theight: fit-content;\n\t\t\t// }\n\n\t\t\t// &> :first-child {\n\t\t\t// \t@media only screen and (max-width: $bp-800) {\n\t\t\t// \t\tgrid-row: 2;\n\t\t\t// \t\tgrid-column: 1/2;\n\t\t\t// \t}\n\t\t\t// }\n\n\t\t\t// &> :nth-child(2) {\n\t\t\t// \t@media only screen and (max-width: $bp-800) {\n\t\t\t// \t\tgrid-row: 1;\n\t\t\t// \t\tgrid-column: 1/3;\n\t\t\t// \t}\n\t\t\t// }\n\n\t\t\t// &> :last-child {\n\t\t\t// \t@media only screen and (max-width: $bp-800) {\n\t\t\t// \t\tgrid-row: 2;\n\t\t\t// \t\tgrid-column: 2/3;\n\t\t\t// \t}\n\t\t\t// }\n\t\t}\n\n\t\t&__nav {\n\t\t\tmin-height: 4rem;\n\t\t\tborder-bottom: 0.5px solid #d8d8d8;\n\t\t\tpadding: 0 5rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t&__selected {\n\t\t\t\tborder-bottom: 1px solid var(--color-dark);\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\n\t\t\tul {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tlist-style: none;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\tgap: 1.5rem;\n\n\t\t\t\tli {\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tborder-bottom: 1px solid var(--color-dark);\n\t\t\t\t\t\twidth: fit-content;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// align-items: center;\n\n\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\tpadding: 0 2rem;\n\t\t\t}\n\n\t\t\t&__more {\n\t\t\t\twidth: 100%;\n\t\t\t\t// position: absolute;\n\t\t\t\t// position: sticky;\n\t\t\t\t// top: 0;\n\t\t\t\t// left: 0;\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\t\tz-index: 12;\n\t\t\t\tmin-height: 40vh;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__body {\n\t\tposition: relative;\n\t\tmargin-top: 13rem;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tmargin-top: 17rem;\n\t\t}\n\n\t\t&__inner {\n\t\t\tpadding: 0 5rem;\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\tpadding: 0 2rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__icons {\n\t\tfont-size: 3rem;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\n\t\t&>* {\n\t\t\tcursor: pointer;\n\t\t\ttransition: transform 0.3s ease-in-out;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: scale(1.1);\n\t\t\t}\n\t\t}\n\n\t}\n\n\t&__search {\n\t\t&__icon {\n\t\t\tfont-size: 3rem;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\talign-items: center;\n\n\n\t\t\t// @media only screen and (max-width: $bp-500) {\n\t\t\t// \tposition: absolute;\n\t\t\t// \ttop: 0.2rem;\n\t\t\t// \tright: 2rem;\n\t\t\t// }\n\t\t}\n\n\t}\n\n\t&__embla {\n\t\t&__viewport {\n\t\t\toverflow: hidden;\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&__container {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t&__slide {\n\t\t\tflex: 0 0 100%;\n\t\t\tmin-width: 0;\n\t\t}\n\n\t\t&__btn {\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1rem;\n\t\t\tfont-size: 2rem;\n\t\t\tborder-radius: 3px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tpadding: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\n\t\t&__btns {\n\t\t\tdisplay: flex;\n\t\t\twidth: 100%;\n\t\t\tgap: 2rem;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tposition: absolute;\n\t\t\ttop: 40%;\n\t\t\tpadding: 1rem;\n\t\t}\n\n\t\t&__onSale {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 600;\n\t\t\tpadding: 1rem;\n\t\t\twidth: fit-content;\n\t\t\tposition: absolute;\n\t\t\ttop: 1rem;\n\t\t\tleft: 1rem;\n\t\t}\n\n\t\t&__prev {\n\t\t\tleft: 1.5rem;\n\t\t}\n\n\t\t&__next {\n\t\t\tright: 1.5rem;\n\t\t}\n\n\t\t&__dots {\n\t\t\tcontent: '';\n\t\t\tdisplay: flex;\n\t\t\tgap: 0.5rem;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 2rem;\n\n\t\t\t&>* {\n\t\t\t\twidth: 2rem;\n\t\t\t\theight: 2rem;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tborder: 1px solid var(--color-fash-primary-2);\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: var(--color-fash-primary-2);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__active {\n\t\t\t\tbackground-color: var(--color-fash-primary-2);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__modal {\n\t\tbackground-color: #2a2828b3;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\theight: 100vh;\n\t\tposition: fixed;\n\t\twidth: 100vw;\n\t\tz-index: 100;\n\n\t\t&__nav {\n\t\t\theight: fit-content;\n\t\t\tmax-height: 60vh;\n\t\t\twidth: fit-content;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tdisplay: flex;\n\n\t\t\t&> :first-child {\n\t\t\t\tmin-width: 30rem;\n\t\t\t\tmax-width: 40rem;\n\t\t\t\tpadding: 2rem;\n\t\t\t\tpadding-right: 4rem;\n\t\t\t\toverflow-y: auto;\n\n\t\t\t\tul {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 1rem;\n\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tfont-size: 1.6rem;\n\t\t\t\t\t\tline-height: 1.9rem;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\tborder-bottom: 1px solid var(--color-dark);\n\t\t\t\t\t\t\twidth: fit-content;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__explore {\n\t\t\t\tflex-grow: 1;\n\t\t\t\tbackground-image: linear-gradient(97deg,\n\t\t\t\t\t\trgba(41, 35, 1, 0.7) 35%,\n\t\t\t\t\t\trgba(12, 9, 13, 0.7) 80%),\n\t\t\t\t\turl('../../img/amazingStyles.jpg');\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tpadding: 2rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-end;\n\t\t\t}\n\t\t}\n\n\t\t&> :last-child {\n\t\t\theight: 40vh;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t&__banner {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-end;\n\t\talign-items: center;\n\t\tmin-height: 60rem;\n\t\tbackground-size: cover;\n\t\tbackground-position: center;\n\t\tbackground-repeat: no-repeat;\n\t\tpadding: 5rem 0;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tmin-height: 60vh;\n\t\t}\n\n\t\t&__text {\n\t\t\tfont-size: 3.2rem;\n\t\t\tcolor: var(--color-white);\n\t\t\twidth: fit-content;\n\t\t\tmax-width: 80%;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n}\n\n.more {\n\theight: fit-content;\n\tmax-height: 60vh;\n\twidth: fit-content;\n\tbackground-color: var(--color-white);\n\tdisplay: flex;\n\tmin-width: 35rem;\n\tmax-width: 40rem;\n\tpadding: 2rem;\n\tpadding-right: 4rem;\n\toverflow-y: auto;\n\tposition: absolute;\n\tright: 0;\n\tz-index: 101;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tright: auto;\n\t\ttop: 3rem;\n\t}\n\n\tul {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tfont-weight: 500;\n\n\t\tli {\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 1.6rem;\n\t\t\tline-height: 1.9rem;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: 1px solid var(--color-dark);\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__rel {\n\t\tposition: relative;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n\n.more2 {\n\theight: fit-content;\n\tmax-height: 60vh;\n\twidth: fit-content;\n\tbackground-color: var(--color-white);\n\tdisplay: flex;\n\tmin-width: 35rem;\n\tmax-width: 40rem;\n\tpadding: 2rem;\n\tpadding-right: 4rem;\n\toverflow-y: auto;\n\tposition: absolute;\n\tright: 0;\n\ttop: 3rem;\n\tz-index: 101;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tright: -10vw;\n\t}\n\n\t@media only screen and (max-width: $bp-400) {\n\t\tright: -13vw;\n\t}\n\n\tul {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tfont-weight: 500;\n\n\t\tli {\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 1.6rem;\n\t\t\tline-height: 1.9rem;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: 1px solid var(--color-dark);\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.single {\n\tpadding: 10rem 5rem;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tpadding: 5rem 2rem;\n\t}\n\n\t&__grid2 {\n\t\tdisplay: grid;\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 2rem;\n\t}\n\n\t&__grid {\n\t\tdisplay: grid;\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: 100%;\n\t\t}\n\n\t\t&__images {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 10rem 1fr;\n\t\t\tgap: 2rem;\n\n\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\tgrid-template-columns: 100%;\n\n\t\t\t\t&> :first-child {\n\t\t\t\t\tgrid-row: 2;\n\t\t\t\t}\n\n\t\t\t\t&> :last-child {\n\t\t\t\t\tgrid-row: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__main {\n\t\t\t\twidth: 100%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tposition: relative;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__list {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2rem;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t}\n\n\t\t\t\t&__sel {\n\t\t\t\t\tborder: 1px solid var(--color-fash-primary-2);\n\t\t\t\t\theight: fit-content;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t}\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 10rem;\n\t\t\t\t\theight: 10rem;\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\tpadding: 1rem;\n\t\t\t\t\tborder-radius: 1rem;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t\t@media only screen and (max-width: $bp-400) {\n\t\t\t\t\t\twidth: 9rem;\n\t\t\t\t\t\theight: 9rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&__details {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n\n\t&__price {\n\t\tborder: 1px solid var(--color-grey);\n\t\tpadding: 2rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 2rem;\n\n\t\t&> :nth-child(2) {\n\t\t\tfont-size: var(--default-font-subtitle);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t&__active {\n\t\t\tborder: 2px solid var(--color-fash-primary-2);\n\n\t\t\t&> :nth-child(2) {\n\t\t\t\tcolor: var(--color-fash-primary-2);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.h {\n\t&__divider {\n\t\tcontent: '';\n\t\tborder: 1px solid var(--color-grey);\n\t\twidth: 100%;\n\t\tmargin: 2rem 0;\n\t}\n}\n\n.zoomed {\n\tdisplay: block;\n\tcursor: pointer;\n\n\t&__image {\n\t\tbackground-size: 300% auto;\n\t\t/* Adjust the background size for zoom level */\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\ttransition: transform 0.1s ease-in-out;\n\t\tdisplay: block;\n\t}\n}\n\n.country {\n\tposition: relative;\n\n\t&__sel {\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\timg {\n\t\t\twidth: 5rem;\n\t\t}\n\t}\n\n\t&__drop {\n\t\tposition: absolute;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 8px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tcursor: pointer;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tbackground-color: var(--color-white);\n\t\tmin-width: 20rem;\n\n\t\ttop: 5rem;\n\t\tleft: 0;\n\t\tz-index: 12;\n\n\t\t&> :first-child {\n\t\t\t&:hover {\n\t\t\t\tborder-radius: 8px 8px 0 0;\n\t\t\t}\n\t\t}\n\n\t\t&> :last-child {\n\t\t\t&:hover {\n\t\t\t\tborder-radius: 0 0 8px 8px;\n\t\t\t}\n\t\t}\n\n\t\t&__item {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t\tpadding: 1rem;\n\t\t\talign-items: center;\n\n\t\t\timg {\n\t\t\t\twidth: 5rem;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.cartIcon {\n\tposition: relative;\n\n\t&__nos {\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t\tfont-size: 7px;\n\t\tborder-radius: 50%;\n\t\theight: 1.5rem;\n\t\twidth: 1.5rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: absolute;\n\t\ttop: -5px;\n\t\tright: -5px;\n\t}\n}\n\n.sales {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 1rem;\n\n\t&__cancel {\n\t\ttext-decoration: line-through;\n\t}\n}\n\n.shopTitle {\n\tfont-size: 4rem;\n\tfont-weight: 400;\n\tline-height: 4rem;\n\tmargin-top: 16rem;\n\ttext-align: center;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tmargin-top: 19rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Catalogue_container__JrNJF`,
	"container_heading": `Catalogue_container_heading__jlOxk`,
	"container_heading__shape": `Catalogue_container_heading__shape__24mmg`,
	"breadCrumbs": `Catalogue_breadCrumbs__c7Z4N`,
	"inActive": `Catalogue_inActive__SV2JE`,
	"breadCrumbsBox": `Catalogue_breadCrumbsBox__F7V3S`,
	"imageContainer": `Catalogue_imageContainer__dQ7yK`,
	"smallImages": `Catalogue_smallImages__kBUTJ`,
	"smallImage": `Catalogue_smallImage__Kfayp`,
	"largeImageContainer": `Catalogue_largeImageContainer__GURF9`,
	"largeImage": `Catalogue_largeImage__-bT91`,
	"selectedSmallImage": `Catalogue_selectedSmallImage__yXaBO`,
	"selectedLargeImage": `Catalogue_selectedLargeImage__cBU+7`,
	"section": `Catalogue_section__riptd`,
	"section_form": `Catalogue_section_form__8YV42`,
	"line": `Catalogue_line__P+mlY`,
	"btn": `Catalogue_btn__ENN2Y`,
	"pagination": `Catalogue_pagination__soD-m`,
	"active": `Catalogue_active__zc7Hz`,
	"dtl": `Catalogue_dtl__CqjzB`,
	"img": `Catalogue_img__ULSd4`,
	"catalog": `Catalogue_catalog__ZArYc`,
	"catalog__header": `Catalogue_catalog__header__JYqu6`,
	"catalog__header__business": `Catalogue_catalog__header__business__IYbUw`,
	"catalog__header__business__name": `Catalogue_catalog__header__business__name__HpfVg`,
	"catalog__header__inner": `Catalogue_catalog__header__inner__ev96X`,
	"catalog__header__nav": `Catalogue_catalog__header__nav__J1zqd`,
	"catalog__header__nav__selected": `Catalogue_catalog__header__nav__selected__5syDX`,
	"catalog__header__nav__more": `Catalogue_catalog__header__nav__more__nBxuh`,
	"catalog__body": `Catalogue_catalog__body__BqAwt`,
	"catalog__body__inner": `Catalogue_catalog__body__inner__dPptR`,
	"catalog__icons": `Catalogue_catalog__icons__Crjop`,
	"catalog__search__icon": `Catalogue_catalog__search__icon__xalVa`,
	"catalog__embla__viewport": `Catalogue_catalog__embla__viewport__44tlG`,
	"catalog__embla__container": `Catalogue_catalog__embla__container__EEG4d`,
	"catalog__embla__slide": `Catalogue_catalog__embla__slide__L8m+F`,
	"catalog__embla__btn": `Catalogue_catalog__embla__btn__RB8da`,
	"catalog__embla__btns": `Catalogue_catalog__embla__btns__Hqrxo`,
	"catalog__embla__onSale": `Catalogue_catalog__embla__onSale__qGZ+l`,
	"catalog__embla__prev": `Catalogue_catalog__embla__prev__kk0vl`,
	"catalog__embla__next": `Catalogue_catalog__embla__next__xElko`,
	"catalog__embla__dots": `Catalogue_catalog__embla__dots__mx8b4`,
	"catalog__embla__dots__active": `Catalogue_catalog__embla__dots__active__eb0jM`,
	"catalog__modal": `Catalogue_catalog__modal__yAlsu`,
	"catalog__modal__nav": `Catalogue_catalog__modal__nav__5N4iS`,
	"catalog__modal__nav__explore": `Catalogue_catalog__modal__nav__explore__zIgs0`,
	"catalog__banner": `Catalogue_catalog__banner__Uc8V7`,
	"catalog__banner__text": `Catalogue_catalog__banner__text__4rzqj`,
	"more": `Catalogue_more__Wzrfv`,
	"more__rel": `Catalogue_more__rel__J+TKy`,
	"more2": `Catalogue_more2__BvmpF`,
	"single": `Catalogue_single__kR15W`,
	"single__grid2": `Catalogue_single__grid2__9I-0-`,
	"single__grid": `Catalogue_single__grid__JhRMo`,
	"single__grid__images": `Catalogue_single__grid__images__0qfnT`,
	"single__grid__images__main": `Catalogue_single__grid__images__main__vI+eL`,
	"single__grid__images__list": `Catalogue_single__grid__images__list__6RcNh`,
	"single__grid__images__list__sel": `Catalogue_single__grid__images__list__sel__DOJIi`,
	"single__grid__details": `Catalogue_single__grid__details__BP+Od`,
	"single__price": `Catalogue_single__price__fZR4u`,
	"single__price__active": `Catalogue_single__price__active__ldhx0`,
	"h__divider": `Catalogue_h__divider__b6znT`,
	"zoomed": `Catalogue_zoomed__iv2+T`,
	"zoomed__image": `Catalogue_zoomed__image__y6y6i`,
	"country": `Catalogue_country__07rsU`,
	"country__sel": `Catalogue_country__sel__rq50m`,
	"country__drop": `Catalogue_country__drop__o6hJh`,
	"country__drop__item": `Catalogue_country__drop__item__KR28h`,
	"cartIcon": `Catalogue_cartIcon__FBh8Q`,
	"cartIcon__nos": `Catalogue_cartIcon__nos__EK9a6`,
	"sales": `Catalogue_sales__1uDUQ`,
	"sales__cancel": `Catalogue_sales__cancel__OqXeN`,
	"shopTitle": `Catalogue_shopTitle__R7rwz`
};
export default ___CSS_LOADER_EXPORT___;
